import { motion } from "framer-motion";
import { Plane } from "lucide-react";
import { PORTS } from "@/data/content";

export default function Ports() {
  return (
    <section
      id="ports"
      data-testid="ports-section"
      className="border-b border-[#E4E7EC] bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-8 md:py-28">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="overline mb-4">§ 04 — Coverage</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight text-[#101828] sm:text-5xl md:text-6xl">
              Every major Indian <span className="text-[#D92D20]">port & airport.</span>
            </h2>
            <p className="mt-6 max-w-md text-base leading-relaxed text-[#475467]">
              We clear at every Air Cargo Complex, Courier Terminal, and
              Inland Container Depot that matters. Route your cargo through the
              gateway with the fastest turnaround for your destination pincode.
            </p>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-[#475467]">
              Search-friendly aliases:{" "}
              <em>customs clearance agent Delhi</em>,{" "}
              <em>Mumbai customs broker</em>,{" "}
              <em>Bangalore CHA</em>,{" "}
              <em>Hyderabad pharma customs clearance</em>,{" "}
              <em>Chennai customs house agent</em>,{" "}
              <em>Kolkata customs clearance</em>,{" "}
              <em>Cochin Gulf forwarder desk</em>,{" "}
              <em>ICD Tughlakabad clearance</em>.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-0 border-2 border-[#101828]">
              {PORTS.map((p, i) => (
                <motion.div
                  key={p.code}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.35, delay: i * 0.03 }}
                  className={`p-5 md:p-6 ${
                    i % 2 === 0 ? "border-r border-[#101828]" : ""
                  } ${i < PORTS.length - 2 ? "border-b border-[#101828]" : ""}`}
                  data-testid={`port-${p.code}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="font-display text-2xl font-black tracking-tight text-[#101828]">
                      {p.code}
                    </span>
                    <Plane className="h-4 w-4 text-[#D92D20]" strokeWidth={2.5} />
                  </div>
                  <div className="mt-2 text-sm font-semibold text-[#101828]">
                    {p.city}
                  </div>
                  <div className="font-mono-accent mt-1 text-[#D92D20]">
                    {p.type}
                  </div>
                  <div className="mt-3 text-xs leading-relaxed text-[#475467]">
                    {p.ops}
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
